import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Assigns and unassigns Vehicles to Vehicle Groups
 * @param vehicleGroupId The ID of the Vehicle Group the Vehicles are being assigned to
 * @param assignmentVehicleIds The Vehicles being assigned
 * @param unassignmentVehicleIds The Vehicles being unassigned
 * @returns Data object containing the newly created Vehicle Groups
 */
export function postVehicleGroupsVehiclesCombinedAssignment(
  this: unknown,
  vehicleGroupId: number,
  assignmentVehicleIds: string[],
  unassignmentVehicleIds: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .vehicleGroupsVehiclesCombinedAssignmentUrl(String(vehicleGroupId)),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            assignmentVehicleIds,
            unassignmentVehicleIds,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.object({
          assigned: z.array(z.string()),
          unassigned: z.array(z.string()),
        }),
      })
    )
  );
}
